import React, { useState, useEffect, useRef } from 'react';
import Dropdown from '../../../../Components/Dropdown';
import Input from '../../../../Components/Input';
import Loader from '../../../../Components/Loader';
import DeleteConfirmationModal from '../../../../Components/Modals/DeleteConformationModal';
import DateInput from '../../../../Components/DateInput';
import UserAdditionalInformationController from '../../../Controllers/AdminScreens/Users/UserAdditionalInformationController';
import LoadingSkeleton from '../../../../Components/LoadingSkeleton';

const UserAdditionalInformationScreen = ({ isUserEditable, userInfo, loading, error,onRefresh}) => {
    const {
        handleUpdateUser,
        handleCancel,
        fieldConfigs,
        additionalData,
        handleInputChange,
        updateDeleteError,
        updateDeleteSuccess,
        updateLoading,
        isEditModalOpen,
        handleOpenEditModal,
        handleCloseEditModal,
        callUpdateUserAdditionalInfo,
    } = UserAdditionalInformationController(userInfo, isUserEditable,onRefresh);

    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const toggleDropdown = (name) => {
        setOpenDropdown(prev => prev === name ? null : name);
    };

    return (
        <div className='basic-info-container'>
            <h3 className='basic-info-header'>HR Information</h3>
            <div className='basic-info-card' style={{ border: 'none' }}>
                <div className='form-grid'>
                    {fieldConfigs.map((field) => (
                        <div className="basic-info-item" key={field.key}>
                            {isUserEditable ? (
                                field.type === "dropdown" ? (
                                    <Dropdown
                                        ref={(el) => (dropdownRefs.current[`${field?.label}`] = el)}
                                        isOpen={openDropdown === `${field?.label}`}
                                        toggleDropdown={() => toggleDropdown(`${field?.label}`)}
                                        label={field?.label}
                                        options={field.options}
                                        value={additionalData[field.key]}
                                        onChange={(selectedValue) => handleInputChange(field.key, selectedValue)}
                                        loading={field?.loading}
                                    />
                                    // ) : field.type === "date" ? (
                                    //     <div className="basic-info-label">
                                    //         <label>{field?.label}</label>
                                    //         <DateInput
                                    //             value={additionalData[field.key] || ""}
                                    //             onChange={(e) => handleInputChange(field.key, e.target.value)}
                                    //             errorMessage={field?.error}
                                    //         />
                                    //     </div>
                                ) : (
                                    <Input
                                        label={field?.label}
                                        placeholder={field.key === 'disbursement_amount'
                                            ? field?.label
                                            : `Enter ${field?.label}`}
                                        value={additionalData[field.key] ?? ""}
                                        onChange={(e) => handleInputChange(field.key, e.target.value)}
                                        errorMessage={field?.error}
                                        isEdit={!(field.key === 'disbursement_amount')}
                                    />
                                )
                            ) : (
                                <>
                                    <span className="basic-info-label">{field?.label}</span>
                                    <span className="basic-info-value">
                                        {loading ? (
                                            <LoadingSkeleton width="40%" height="10px" />
                                        ) : (() => {
                                            const value = additionalData[field.key];

                                            // Boolean flags as Yes/No
                                            if (["is_pf", "is_esi", "is_pt", "is_variable_pay"].includes(field.key)) {
                                                return value === 1 ? "Yes" : value === 0 ? "No" : "--";
                                            }

                                            // Payment mode: 1 => Online, 2 => Offline
                                            if (field.key === "emp_payment_mode") {
                                                return value === 1 ? "Online" : value === 2 ? "Offline" : "--";
                                            }

                                            // Other fields - show value or '--'
                                            return value?.toString()?.trim() ? value : "--";
                                        })()}
                                    </span>
                                </>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {updateDeleteError && <div className="list-error-msg">{updateDeleteError}</div>}
            {updateDeleteSuccess && <div className="list-success-msg">{updateDeleteSuccess}</div>}

            <div className="button-container" style={{ gap: 20 }}>
                {isUserEditable && (
                    <>
                        <button onClick={handleUpdateUser} className="add-client-button" style={{ opacity: updateLoading ? 0.5 : 1, cursor: updateLoading ? 'not-allowed' : 'pointer' }}>
                            {updateLoading && (
                                <span style={{ paddingRight: 10 }}><Loader loading={updateLoading} color={'var(--background-color)'} size="small" /> </span>
                            )}Update User
                        </button>
                        <button onClick={handleCancel} className="tasksScreen-cancel-button">Cancel</button>
                    </>
                )}
            </div>

            <DeleteConfirmationModal
                isOpen={isEditModalOpen}
                message={`Are you sure you want to update user?`}
                onClose={handleCloseEditModal}
                onConfirm={() => {
                    handleCloseEditModal();
                    callUpdateUserAdditionalInfo();
                }}
            />
        </div>
    );
};

export default UserAdditionalInformationScreen;
